module.exports = __webpack_public_path__ + "static/media/search_icon.c7c49527.svg";